export const subjects = [
    { value: "გერმანული", label: "გერმანული" },
    { value: "ფრანგული", label: "ფრანგული" },
    { value: "ინგლისური", label: "ინგლისური" },
    { value: "ისტორია", label: "ისტორია" },
    { value: "მათემატიკა", label: "მათემატიკა" },
    { value: "მუსიკა", label: "მუსიკა" },
    { value: "სამოქალაქო", label: "სამოქალაქო" },
    { value: "ბიოლოგია", label: "ბიოლოგია" },
    { value: "გეოგრაფია", label: "გეოგრაფია" },
    { value: "პროგრამირება", label: "პროგრამირება" },
    { value: "აიტი", label: "აიტი" },
    { value: "რუსული", label: "რუსული" },
    { value: "ქართული", label: "ქართული" },
    { value: "ბუნება", label: "ბუნება" },
    { value: "ჭადრაკი", label: "ჭადრაკი" },
    { value: "ხელოვნება", label: "ხელოვნება" },
    { value: "ფიზიკა", label: "ფიზიკა" },
    { value: "ქიმია", label: "ქიმია" },
    { value: "იტალიური", label: "იტალიური" },
];